// @ constants
const actionTypes = require('constants/actionTypes');

const stateReset = () => ({
    type: actionTypes.OPENYOUNG_CARD_REJECT_CHORE_RESET
});

const setRemark = (remark) => ({
    type: actionTypes.OPENYOUNG_CARD_REJECT_CHORE_SET_REMARK,
    payload: {
        remark
    }
});

const validateStep = (step) =>({
    type: actionTypes.OPENYOUNG_CARD_REJECT_CHORE_VALIDATE_STEP,
    payload: {
        step
    }
});

const setVisibleStep = (step) => ({
    type: actionTypes.OPENYOUNG_CARD_REJECT_CHORE_SET_VISIBLE_STEP,
    payload: {
        step
    }
})

const setWillCancel = (willCancel) => ({
    type: actionTypes.OPENYOUNG_CARD_REJECT_CHORE_WILL_CANCEL,
    payload: {
        willCancel
    }
});

module.exports = {
    setRemark,
    setVisibleStep,
    setWillCancel,
    stateReset,
    validateStep
}
